import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { UnobtrusiveValidation } from "@Validation/UnobtrusiveValidation";
import IMask from "imask/holder";
import "imask/masked/pattern"
import Modal from "bootstrap/js/dist/modal";

import "./Index.scss";

class Index extends BasePage
{
	public ContactForm: HTMLFormElement | null = document.querySelector("#contactModal form") as HTMLFormElement | null;
	public ContactModal: HTMLElement | null = document.querySelector("#contactModal") as HTMLElement | null;
	public ContactValidation: UnobtrusiveValidation;
	public JobAlertForm: HTMLFormElement | null = document.querySelector("#jobAlertModal form") as HTMLFormElement | null;
	public JobAlertModal: HTMLElement | null = document.querySelector("#jobAlertModal") as HTMLElement | null;
	public JobAlertValidation: UnobtrusiveValidation;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();

		this.ConfigureContactForm();
		this.ConfigureJobAlertForm();
	};

	private ConfigureContactForm = (): void =>
	{
		if (this.ContactForm)
		{
			this.ContactValidation = new UnobtrusiveValidation(this.ContactForm as HTMLFormElement);

			const emailInput = document.getElementById("contactEmail") as HTMLInputElement;

			if (emailInput !== null)
			{
				IMask(
					emailInput,
					{
						mask: /^\S*@?\S*$/
					}
				)
			}

			this.ContactModal?.addEventListener("hidden.bs.modal", () =>
			{
				this.ContactForm?.reset();
				this.ContactValidation.ResetValidation(this.ContactForm as HTMLFormElement);
			});
		}
	}

	private ConfigureJobAlertForm = (): void =>
	{
		if (this.JobAlertForm)
		{
			this.JobAlertValidation = new UnobtrusiveValidation(this.JobAlertForm as HTMLFormElement);

			const emailInput = document.getElementById("jobAlertEmail") as HTMLInputElement;

			if (emailInput !== null)
			{
				IMask(
					emailInput,
					{
						mask: /^\S*@?\S*$/
					}
				)
			}

			this.JobAlertModal?.addEventListener("hidden.bs.modal", () =>
			{
				this.JobAlertForm?.reset();
				this.JobAlertValidation.ResetValidation(this.JobAlertForm as HTMLFormElement);
			});
		}
	}
}

const index = new Index();